module.exports = __webpack_public_path__ + "img/icon-sunny.f11c8251.svg";